import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as auth from '@core/store/ducks/auth.duck';
import { STORAGE_KEYS } from '@core/constants/storage';

class Logout extends Component {
    componentDidMount () {
        localStorage.removeItem(STORAGE_KEYS.SESSION_USER);
        localStorage.removeItem(STORAGE_KEYS.NEW_EMAIL);
        localStorage.removeItem(STORAGE_KEYS.RECOVER_TOKEN);
        this.props.logout();
    }

    render () {
        const { hasAuthToken } = this.props;

        return hasAuthToken ? <div>logout</div> : <Redirect to="/auth" />;
    }
}

export default connect(
    ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
    auth.actions
)(Logout);
